<template>
  <div>
    <vx-modal nameClass="Component_actions" :title="'Subformularios'" width="50%">
      <template v-slot:body>
        <!-- <div v-for="(fruta, g) in frutas" :key="g">
          <vs-checkbox :value="data.some(x => x.id === fruta.id)" :vs-value="fruta" @change="Verify(fruta)">{{
            fruta.fruta
          }}</vs-checkbox>
        </div>
        {{ data }} -->

        <div class="absoluted flex justify-start">
          <div class="w-1/2 bg-white border">
            <div class="border border-t-0 border-l-0 border-r-0 flex items-center pxs-2 pys-2">
              <i class="material-icons p-0 m-0 bg-successf"> search </i>
              <input
                v-model.trim="search"
                class="w-full border-0 rounded-lg h-8 px-2"
                type="text"
                :placeholder="$t(`MODALS.actions.search`)"
              />
            </div>
            <div class="px-1 py-3 overflow-auto" style="height: 15.625rem">
              <div
                @click="
                  questionsBySubForms = question.questions;
                  keySubformSelected = question.formID;
                "
                class="flex items-start"
                :class="{
                  'border border-t-0 border-l-0 border-r-0 py-2 px-2 last-item':
                    data.length === 0 || (data.length > 0 && keySubformSelected === question.formID),
                  subFormSelected: keySubformSelected === question.formID
                }"
                v-for="(question, j) in searchQuestions"
                :key="j"
              >
                <div
                  class="flex flex-col w-full cursor-pointer"
                  v-if="data.length === 0 || (data.length > 0 && keySubformSelected === question.formID)"
                >
                  <div class="flex justify-between">
                    <span class="font-bold">{{ question.name }}</span>
                    <span>{{ $t(`INPUTTYPE.${question.type}.${question.inputType}`) }}</span>
                  </div>
                  <div class="flex justify-between items-center">
                    <div>{{ question.label }}</div>
                    <div class="flex">
                      <vs-avatar color="primary" :text="String(data.length)" />
                      <vs-button
                        disabled
                        color="success"
                        size="large"
                        type="flat"
                        icon-pack="feather"
                        icon="icon-arrow-right"
                      ></vs-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="w-1/2 bg-white border">
            <div class="border border-t-0 border-l-0 border-r-0 flex items-center pxs-2 pys-2">
              <i class="material-icons p-0 m-0 bg-successf"> search </i>
              <input
                v-model.trim="searchQuestion"
                class="w-full border-0 rounded-lg h-8 px-2"
                type="text"
                :placeholder="$t(`MODALS.actions.search`)"
              />
            </div>
            <div class="px-1 py-3 overflow-auto" style="height: 15.625rem">
              <div
                v-if="questionsBySubForms.length > 0"
                class="flex items-start border border-t-0 border-l-0 border-r-0 py-2 px-2 last-item"
              >
                <vs-checkbox @change="allSelect($event)">All</vs-checkbox>
              </div>
              <div
                class="flex items-start border border-t-0 border-l-0 border-r-0 py-2 px-2 last-item"
                v-for="(question, j) in getQuestionsSubForms"
                :key="j"
              >
                <vs-checkbox
                  :value="data.some(x => x.name === question.data.name)"
                  :vs-value="question.data"
                  @change="addCheckBox(question.data)"
                ></vs-checkbox>
                <div class="flex flex-col w-full cursor-pointer">
                  <div class="flex justify-between">
                    <span class="font-bold">{{ question.name }}</span>
                    <span>{{ $t(`INPUTTYPE.${question.type}.${question.inputType}`) }}</span>
                  </div>
                  <div class="flex justify-between items-center">
                    <div>{{ question.label }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex justify-end py-2 border border-t border-l-0 border-r-0 border-b-0">
              <vs-button color="danger" type="border" @click="closedModal">{{ $t(`MODALS.actions.cancel`) }}</vs-button>
              <vs-button class="ml-3 mr-3" color="success" type="border" @click="sendData">{{
                $t(`MODALS.actions.ToAccept`)
              }}</vs-button>
            </div>
          </div>
        </div>
      </template>
    </vx-modal>
  </div>
</template>

<script>
import { getAllQuestion } from "@/serviforms/designer/indexDB/logic.js";
import { mapState, mapMutations } from "vuex";

export default {
  data: () => ({
    allQuestions: [],
    data: [],
    keySubformSelected: "",
    questionsBySubForms: [],
    search: "",
    searchQuestion: ""
  }),
  async mounted() {
    const result = await getAllQuestion();
    this.allQuestions = result;
    this.mountedData();
  },
  computed: {
    ...mapState("resource", ["questionsByPage", "indexQuestion"]),
    /**
     * Obtiene la posición de la pregunta denhtro de la lista de preguntas del formularios.
     */
    getIndexQuestion() {
      return this.allQuestions.findIndex(question => question.name === this.questionsByPage[this.indexQuestion].name);
    },
    /**
     * Obtiene la lista de preguntas desde la pregunta padre hacia arriba.
     */
    getQuestionsUp() {
      return this.allQuestions.slice(0, this.getIndexQuestion);
    },
    /**
     * Filtra preguntas de tipo subformulario.
     */
    filterQuestions() {
      return this.getQuestionsUp
        .map((question, index) => ({
          name: question.name,
          position: index,
          label: question.label,
          type: question.type,
          inputType: question.inputType,
          ...(question.type === "subform" && {
            formID: question.inherited[0].formID,
            questions: question.inherited[0].form.questions
          })
        }))
        .filter(question => question.type === "subform");
    },
    searchQuestions() {
      return this.filterQuestions.filter(question => {
        if (this.search.length > 0) {
          const condition1 = question.name.toLowerCase().includes(this.search.toLowerCase());
          const condition2 = question.label.toLowerCase().includes(this.search.toLowerCase());
          return condition1 || condition2;
        }
        return true;
      });
    },
    /**
     * Filtra las preguntas del subformualrios, donde se extraen aquellas que se pueden operan en las acciones.
     */
    getQuestionsSubForms() {
      return this.questionsBySubForms
        .map((question, index) => ({
          ...question,
          data: { name: question.name, position: index, type: "standard" }
        }))
        .filter(
          question =>
            question.inputType === "number" ||
            question.inputType === "currency" ||
            question.inputType === "default" ||
            question.inputType === "action"
        )
        .filter(question => {
          if (this.searchQuestion.length > 0) {
            const condition1 = question.name.toLowerCase().includes(this.searchQuestion.toLowerCase());
            const condition2 = question.label.toLowerCase().includes(this.searchQuestion.toLowerCase());
            return condition1 || condition2;
          }
          return true;
        });
    },
    questions() {
      return this.questionsByPage[this.indexQuestion].actions.questions;
    }
  },
  methods: {
    ...mapMutations("resource", ["UPDATE_STATE"]),
    sendData() {
      const hasForm = this.questionsByPage[this.indexQuestion].actions.questions.findIndex(
        question => question.formID === this.keySubformSelected
      );

      if (hasForm > -1) {
        // this.questionsByPage[this.indexQuestion].actions.questions = this.questionsByPage[
        //   this.indexQuestion
        // ].actions.questions.filter(item => !item.formID && item.formID !== this.keySubformSelected);
        this.closedModal();
        return;
      }
      if (this.data.length > 0) {
        const getQuestion = this.filterQuestions.find(item => item.formID === this.keySubformSelected);
        let question = {
          name: getQuestion.name,
          position: getQuestion.position,
          type: "subform",
          formID: this.keySubformSelected,
          questions: []
        };

        question.questions = this.data;

        this.questionsByPage[this.indexQuestion].actions.questions = [
          ...this.questionsByPage[this.indexQuestion].actions.questions,
          ...[question]
        ];
      }

      this.closedModal();
    },
    closedModal() {
      this.UPDATE_STATE({ key: "activePopup", value: false });
      setTimeout(() => {
        this.UPDATE_STATE({ key: "componentPopup", value: "" });
      }, 50);
    },
    formatQuestions(questions) {
      return questions
        .filter(
          question =>
            question.inputType === "number" ||
            question.inputType === "currency" ||
            question.inputType === "default" ||
            question.inputType === "action"
        )
        .map((question, index) => ({
          name: question.name,
          label: question.label,
          position: index,
          type: question.type,
          inputType: question.inputType
        }));
    },
    allSelect(event) {
      if (event.target.checked) {
        const questions = this.getQuestionsSubForms.map(question => question.data);
        return (this.data = questions);
      }
      this.data = [];
      this.questionsByPage[this.indexQuestion].actions.questions = this.questionsByPage[
        this.indexQuestion
      ].actions.questions.filter(item => !item.formID && item.formID !== this.keySubformSelected);
    },
    mountedData() {
      const subForm = this.questions.find(question => question.type === "subform");
      if (subForm === undefined) return;
      const getQuestions = this.filterQuestions.find(question => question.formID === subForm.formID);

      this.keySubformSelected = subForm.formID;
      this.data = subForm.questions;
      this.questionsBySubForms = getQuestions.questions;
    },
    addCheckBox(question) {
      const findElement = this.data.find(element => element.name === question.name);
      if (findElement === undefined) {
        this.data.push(question);
        return;
      }
      this.data = this.data.filter(item => item.name !== question.name);

      if (this.data.length === 0) {
        this.questionsByPage[this.indexQuestion].actions.questions = this.questionsByPage[
          this.indexQuestion
        ].actions.questions.filter(item => !item.formID && item.formID !== this.keySubformSelected);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.subFormSelected {
  background-color: #f2f2f2;
}
</style>
